import { innCodesMap } from "./InnCodesMap";
import { CardIssuer } from "./CardIssuer";

export class CardIssuerDetector {
  getCardIssuer(cardNumber) {
    const matchedInn = this._getInnMatches(cardNumber);

    if (matchedInn.length) {
      return this._sortMatches(matchedInn)[0].issuer;
    }

    return null;
  }

  _sortMatches(matchedInn) {
    return matchedInn.slice().sort((m1, m2) => {
      const m1IsRange = Array.isArray(m1.code);
      const m2IsRange = Array.isArray(m2.code);

      if (m1IsRange && m2IsRange) {
        const range1StringLength = m1.code[1].toString().length;
        const range2StringLength = m2.code[1].toString().length;

        const diff = range2StringLength - range1StringLength;
        return diff === 0 ? -1 : diff;
      }

      if (m1IsRange) {
        const rangeStringLength = m1.code[1].toString().length;
        const numberStringLength = m2.code.toString().length;

        const diff = numberStringLength - rangeStringLength;
        return diff === 0 ? 1 : diff;
      }

      if (m2IsRange) {
        const rangeStringLength = m2.code[1].toString().length;
        const numberStringLength = m1.code.toString().length;

        const diff = rangeStringLength - numberStringLength;
        return diff === 0 ? -1 : diff;
      }

      const m1Code = m1.code;
      const m2Code = m2.code;

      return m2Code.toString().length - m1Code.toString().length;
    });
  }

  _getInnMatches(value) {
    const matchedInn = [];

    Object.entries(innCodesMap).forEach(([issuer, innArr]) => {
      const matched = innArr.filter((inn) => {
        let res;
        if (Array.isArray(inn)) {
          res = this._valueMathRange(value, inn[0], inn[1]);
        } else {
          res = this._valueMatchNum(value, inn);
        }

        return res;
      });

      matched.forEach((m) => {
        matchedInn.push({
          issuer: CardIssuer[issuer],
          code: m,
        });
      });
    });

    return matchedInn;
  }

  _valueMatchNum(value, num) {
    const numStr = num.toString();

    if (value.length >= numStr.length) {
      return value.startsWith(numStr);
    }

    return false;
  }

  _valueMathRange(value, start, end) {
    const valueNum = Number.parseInt(value.slice(0, end.toString().length));
    return valueNum >= start && valueNum <= end;
  }
}
